import { GatewaysContext } from "./GatewaysContext";
import { useContext } from "react";

export const useGateways = () => useContext(GatewaysContext);
